import type {Suggestions} from '@github-ui/inline-autocomplete/types'
import {useQuery} from '@github-ui/react-query'
import {useMemo} from 'react'

import {useChatManager} from '../../utils/CopilotChatManagerContext'
import {PullRequestSuggestion} from './PullRequestSuggestion'

export interface PullRequestsQuery {
  category: 'pulls'
  repository: string
  filter: string
}

export function usePullRequestsSuggestions(query: PullRequestsQuery | null) {
  const {service} = useChatManager()

  const pullRequestsQuery = useQuery({
    enabled: query !== null,
    queryKey: ['copilot-autocomplete-pulls', query?.repository, query?.filter],
    queryFn: async () => service.fetchAutocompletePullRequests(query!.repository, query!.filter),
  })

  return useMemo<Suggestions | null>(() => {
    if (!query) return null

    if (pullRequestsQuery.isLoading) return 'loading'

    return (
      pullRequestsQuery.data?.map(pull => ({
        value: `${query.repository}/pulls/${pull.number}`,
        key: pull.number.toString(),
        render: props => <PullRequestSuggestion {...props} pullRequest={pull} />,
      })) ?? null
    )
  }, [pullRequestsQuery.data, pullRequestsQuery.isLoading, query])
}
